import ApiService from "services/ApiService";

const JourneyTestCaseService = {
    deleteTestCases: async function ({ idsToDelete }) {
        const endpoint = "/test-case/delete";
        return await ApiService.post(endpoint, { ids: idsToDelete });
    },
    regenerateTestCases: async function ({
        journeyId,
        idsToRegenerate,
        regenerateAll = false,
        contextData = null,
    }) {
        const endpoint = `/journeys/test-case/regenerate/${journeyId}`;
        return await ApiService.post(endpoint, {
            idsToRegenerate,
            regenerateAll,
            ...(contextData || {}),
        });
    },
    runTestCases: async function ({ idsToRun }) {
        const endpoint = `/test-case/run`;
        return await ApiService.post(endpoint, { ids: idsToRun });
    },
    stopTestCases: async function ({ journeyId, idToStop }) {
        console.log("Stopping test case with id: ", idToStop);
        const endpoint = `/journeys/test-case/stop/${journeyId}`;
        return await ApiService.post(endpoint, { idToStop });
    },
    updateFeedback: async function ({ testCaseId, value }) {
        const endpoint = `/test-case/feedback/${testCaseId}`;
        return await ApiService.put(endpoint, { value });
    },
    generateTestCases: async function ({journeyId, contextData}) {
        const endpoint = `/journeys/test-cases/${journeyId}`;
        return await ApiService.post(endpoint, contextData || {});
    },
};

export default JourneyTestCaseService;
